/** Payload / UI field keys for Reserve → Outlet Setup (aligned with Retail outlet setup). */
export const RESERVE_OUTLET_FIELD_OUTLET_NAME = "Outlet Name";
export const RESERVE_OUTLET_FIELD_TERMINAL_ID = "Terminal ID";
export const RESERVE_OUTLET_FIELD_PROFIT_CENTER_ID = "Profit Center ID";
export const RESERVE_OUTLET_FIELD_AUTO_PRINT_RECEIPTS = "Auto Print Receipts";
export const RESERVE_OUTLET_FIELD_ACTIVE = "Active";
